var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-CPPerformanceReport" },
    [
      _c(
        "el-form",
        {
          ref: "searchForm",
          attrs: {
            model: _vm.searchValue,
            size: "small",
            inline: "",
            "label-position": "top",
          },
        },
        [
          _vm.isMonthly
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("sfe.CPPerformanceReport.select.month"),
                  },
                },
                [
                  _c("FormDatePicker", {
                    attrs: {
                      val: _vm.searchValue.value,
                      valueformat: "yyyyMM",
                      type: "month",
                      clearable: false,
                      editable: false,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.searchValue, "value", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "export-button", attrs: { label: " " } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: {
                        pageName: "CPPerformanceReport",
                        list: ["EXPORT"],
                      },
                      expression:
                        "{ pageName: 'CPPerformanceReport', list: ['EXPORT'] }",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.exportHandler },
                },
                [_vm._v(_vm._s(_vm.$t("common.export")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "highlight-current-row": "",
            "tooltip-effect": "dark",
            "default-sort": _vm.defaultSort,
          },
          on: { "sort-change": _vm.sortTable },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "srEmpNo",
              label: _vm.$t("sfe.CPPerformanceReport.table.srEmpNo"),
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "srEmpName",
              label: _vm.$t("sfe.CPPerformanceReport.table.srEmpName"),
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "visitStoreFrequency",
              label: _vm.$t(
                "sfe.CPPerformanceReport.table.visitStoreFrequency"
              ),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "visitClubQty",
              label: _vm.$t("sfe.CPPerformanceReport.table.visitClubQty"),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "visitClubFrequency",
              label: _vm.$t("sfe.CPPerformanceReport.table.visitClubFrequency"),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "visitClubFrequencyMixString",
              label: _vm.$t(
                "sfe.CPPerformanceReport.table.visitClubFrequencyMix"
              ),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "visitCrossStoreQty",
              label: _vm.$t("sfe.CPPerformanceReport.table.visitCrossStoreQty"),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "visitCrossStoreFrequency",
              label: _vm.$t(
                "sfe.CPPerformanceReport.table.visitCrossStoreFrequency"
              ),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "visitCrossStoreFrequencyMixString",
              label: _vm.$t(
                "sfe.CPPerformanceReport.table.visitCrossStoreFrequencyMix"
              ),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "z02StoreQty",
              label: _vm.$t("sfe.CPPerformanceReport.table.z02StoreQty"),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "z02StoreFrequency",
              label: _vm.$t("sfe.CPPerformanceReport.table.z02StoreFrequency"),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "z02StoreFrequencyMixString",
              label: _vm.$t(
                "sfe.CPPerformanceReport.table.z02StoreFrequencyMix"
              ),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
        on: {
          "update:page": function ($event) {
            _vm.currPage = $event
          },
          "update:limit": function ($event) {
            _vm.limit = $event
          },
          pagination: _vm.fetchData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }